<template>
  <v-container>
    <date-filter @onSearch="onSearch" :variableList="variableList"></date-filter>

    <div class="text-xs-right my-2">
      <v-btn depressed @click="onExport" :loading="loading" color="primary">
        <v-icon class="mr-2">upgrade</v-icon>
        {{ $t('export') }}
      </v-btn>
    </div>
    <v-data-table
      :headers="headers"
      :items="filteredVariables"
      class="elevation-1"
      v-bind:pagination.sync="pagination"
      :rows-per-page-items="[10, 25, 45, { text: $t('All'), value: -1 }]"
      :loading="loading"
    >
      <template v-slot:items="props">
        <td>{{ props.item.first_name }}</td>
        <td>{{ props.item.last_name }}</td>
        <td>{{ props.item.variable }}</td>
        <td>{{ props.item.value }}</td>
        <td>{{ props.item.timestamp | DateFormat('DD/MM/YYYY HH:mm') }}</td>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import api from '@/api'
import { mapGetters, mapMutations } from 'vuex'
import XLSX from 'xlsx'
const DateFilter = () => import('./DateFilter')
export default {
  data() {
    return {
      pagination: { rowsPerPage: 10 },
      headers: [
        {
          text: 'First name',
          value: 'first_name'
        },
        {
          text: 'Last name',
          value: 'last_name'
        },
        {
          text: 'Variable',
          value: 'variable'
        },
        {
          text: 'Value',
          value: 'value'
        },
        {
          text: 'Timestamp',
          value: 'timestamp'
        }
      ],
      variables: [],
      datefrom: '',
      dateto: '',
      filterVariables: [],
      loading: false
    }
  },
  components: {
    DateFilter
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    variableList() {
      var variables = this.variables.map(el => {
        return el.variable
      })
      return variables.filter((v, i) => variables.indexOf(v) === i)
    },
    filteredVariables() {
      if (this.filterVariables.length == 0) {
        return this.variables
      }
      return this.variables.filter(el => {
        return this.filterVariables.includes(el.variable)
      })
    }
  },
  async mounted() {},
  methods: {
    async onSearch({ datefrom, dateto, variables }) {
      this.datefrom = datefrom
      this.dateto = dateto
      this.filterVariables = variables

      var response = await this.getallvariablestransaction()

      this.variables = response.data
    },
    async getallvariablestransaction() {
      return await api.getallvariablestransaction({
        botorigin: this.selectedBot.pageid,
        datefrom: this.datefrom,
        dateto: this.dateto
      })
    },
    onExport() {
      let vm = this
      let csvContent = ''
      if (vm.loading) {
        return false
      }
      let json = []

      json = this.filteredVariables.map(el => {
        return {
          'First name': el.first_name,
          'Last name': el.last_name,
          Variable: el.variable,
          Value: el.value,
          Timestamp: el.timestamp
        }
      })

      const dataWS = XLSX.utils.json_to_sheet(json)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, dataWS)
      XLSX.writeFile(wb, 'tunejai-variables.xlsx')
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/view/analytic/Variables.vue